<!--
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-09-27 18:40:02
 * @LastEditors: yanghui
 * @LastEditTime: 2021-10-20 14:09:35
-->
<template>
    <div>
        <el-form label-position="left" :model="formData" class="query-form" size="small" :rules="formRules"
            ref="dataForm">
            <el-form-item label="消息标题:" prop="msgTitle">
                <el-input placeholder="填写消息标题" v-model="formData.msgTitle" clearable></el-input>
            </el-form-item>
            <el-form-item label="消息内容:" prop="msgContext">
                <el-input type="textarea" autosize placeholder="填写消息内容" v-model="formData.msgContext" clearable>
                </el-input>
            </el-form-item>
        </el-form>


        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click.native="formSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>
    import {
        msgEdit
    } from "@/api/message/message";
    export default {
        data() {
            return {
                loading: false,
                data: {},
                list: [],
                formData: {
                    msgId: "",
                    msgTitle: "",
                    msgContext: ""
                },
                formRules: {
                    msgTitle: [{
                        required: true,
                        message: "请填写消息标题",
                        trigger: "blur"
                    }],
                    msgContext: [{
                        required: true,
                        message: "请填写消息内容",
                        trigger: "blur"
                    }],
                }
            };
        },
        methods: {
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let data = Object.assign({}, this.formData);
                        msgEdit(data)
                            .then(res => {
                                if (res.code) {
                                    this.$message.error(res.message);
                                    return false;
                                }
                                this.$message.success("操作成功");
                                this.$router.go(-1);
                            })
                            .catch(() => {});
                    }
                })
            }
        },
        filters: {},
        mounted() {},
        created() {
            this.formData.msgId = this.$route.query.msgid;
            this.formData.msgContext = this.$route.query.msgcontext;
            this.formData.msgTitle = this.$route.query.msgtitle;
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        }
    };

</script>
<style scoped>


</style>
